// extracted by mini-css-extract-plugin
export default {"edit-button":"events-contributions-client-js-___MyContributions-module__edit-button___ceU9f"};